import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      title: 'Place Your QR Stand',
      description: 'Put the elegant stand on your counter or stick QR stickers at entry points',
      image: 'https://images.pexels.com/photos/7318409/pexels-photo-7318409.jpeg'
    },
    {
      number: '2',
      title: 'Customer Scans QR',
      description: 'Customer scans with their phone camera - WhatsApp opens instantly',
      image: 'https://images.unsplash.com/photo-1569908420024-c8f709b75700'
    },
    {
      number: '3',
      title: 'You Get Connected',
      description: 'You receive their message and can now send offers, updates & stay in touch',
      image: 'https://images.pexels.com/photos/10375901/pexels-photo-10375901.jpeg'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600">
            Setup in 30 seconds. Start collecting leads immediately.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                <div className="relative h-48">
                  <img 
                    src={step.image} 
                    alt={step.title} 
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-4 left-4 bg-green-500 text-white w-12 h-12 rounded-full flex items-center justify-center text-2xl font-bold">
                    {step.number}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <div className="text-green-500 text-4xl">→</div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-lg font-semibold text-gray-900">
            ✅ No app downloads needed | ✅ Works with existing WhatsApp | ✅ Setup in 30 seconds
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;